export const DATE_FORMATS = {
  fourDigitYear: "MM/DD/YYYY",
  twoDigitYear: "MM/D/YY",
};
